import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';
import { strings } from 'config';

class SwitchTabs extends Component {
  constructor(props) {
    super(props);

    this.state = { value: 'np' };

    this.onChange = this.onChange.bind(this);
  }

  componentWillReceiveProps(nextProps) {
    const selectedLang = strings.getLanguage();
    this.setState({
      value: selectedLang === 'en' ? 'en' : 'np'
    });
  }

  onChange(e) {
    let { value, name } = e.target;

    this.setState(
      { value: value },
      () =>
        typeof this.props.onChangeLang === 'function' ? this.props.onChangeLang(name, value) : null
    );
  }

  render() {
    const switchItem1 = this.props.switchItems[0];
    const switchItem2 = this.props.switchItems[1];
    const name = this.props.name;

    return (
      <RadioSwitch>
        <span className="switch radio-switch fixed-width-lg">
          <input
            type="radio"
            id={name + '-' + switchItem1.value}
            checked={this.state.value === switchItem1.value}
            value={switchItem1.value}
            name="radio"
            onChange={this.onChange}
          />
          <label htmlFor={name + '-' + switchItem1.value} style={{ fontSize: '14px' }}>
            {switchItem1.label}
          </label>

          <input
            type="radio"
            id={name + '-' + switchItem2.value}
            checked={this.state.value === switchItem2.value}
            value={switchItem2.value}
            name="radio"
            onChange={this.onChange}
          />
          <label htmlFor={name + '-' + switchItem2.value}>{switchItem2.label}</label>

          <a className="slide-button btn" />
        </span>
      </RadioSwitch>
    );
  }
}

const mapStateToProps = state => {
  return {
    filters: state.filters
  };
};

export default connect(mapStateToProps)(SwitchTabs);

const RadioSwitch = styled.span`
    display: inline-block;
    margin-right: 20px;
  	 .radio-switch {
    // background-color: #eee;
    border-radius: 17px;
    color: #fff;
    text-align: center;
}

.switch {
    display: block;
    height: 28px;
    position: relative;
    border: 1px solid #51c0b8;
}

[for="language-switcher-np"]{
    font-size: 14px;
}

.fixed-width-lg {
    width: 77px !important;
}

input[type="radio"] {
    margin: 3px 0 0;
    margin-top: 1px;
    line-height: normal;
}

.radio-switch input:checked + label {
    color: #fff;
}

.radio-switch label {
    text-transform: uppercase;
    color: #fff;
    font-weight: 400;
    cursor: pointer;
    -webkit-transition: color 0.2s ease-out;
    -o-transition: color 0.2s ease-out;
    transition: color 0.2s ease-out;
}

.switch label {
    position: relative;
    z-index: 2;
    width: 50%;
    height: 100%;
    margin: 0;
    text-align: center;
    float: left;
  font-size: 10px;
  
  }
}

.switch label,
.switch > span {
    line-height: 28px;
    vertical-align: middle;
    font-weight: 600;
}

.radio-switch * {
    outline: 0 !important;
}

.switch input {
    position: absolute;
    opacity: 0;
}

.switch a {
    display: block;
    -webkit-transition: all 0.3s ease-out;
    -o-transition: all 0.3s ease-out;
    transition: all 0.3s ease-out;
}

.switch a {
    position: absolute;
    top: 0;
    padding: 0;
    z-index: 1;
    width: 50%;
    height: 100%;
    color: #fff;
        border-radius: 17px 0 0 17px;
    background-color: #51c0b8;
    left: 0;
    -webkit-box-shadow: "#1B7088" 0 -1px 0 inset;
    box-shadow: "#1B7088" 0 -1px 0 inset;
}

.switch input:last-of-type:checked ~ a {
    background-color: #51c0b8;
   border-radius: 0 14px 14px 0;
    left: 50%;
    -webkit-box-shadow: "#5C5C5C" 0 -1px 0 inset;
    box-shadow: "#5C5C5C" 0 -1px 0 inset;
}


.switch input:checked + label{

	&:after,&:before{
		background: #09d7cb;
	}
}
`;



// WEBPACK FOOTER //
// ./src/components/layouts/switchTabs/switchTabs.js